import request from '../../utils/request';

export const apiService = {
    search: () => {
        return request({
            url: '/mark-category/query',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    deleteById: (id) => {
        console.log(id)
        return request({
            url: '/mark-category/deleteByid/'+id,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            }
        })
    },
    toAddOrUpdate: (data) => {
        return request({
            url: '/mark-category/toAddBigCategory',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}